import { render } from "./BaseWysiwygEditor.vue?vue&type=template&id=eb185a72&scoped=true"
import script from "./BaseWysiwygEditor.vue?vue&type=script&lang=ts"
export * from "./BaseWysiwygEditor.vue?vue&type=script&lang=ts"

import "./BaseWysiwygEditor.vue?vue&type=style&index=0&id=eb185a72&scoped=true&lang=scss"
import "./BaseWysiwygEditor.vue?vue&type=style&index=1&id=eb185a72&lang=scss"
script.render = render
script.__scopeId = "data-v-eb185a72"

export default script